export default function StructuredPeriodAxis({
  groups,
  issues,
  compact = false,
  periodOnly = false,
}) {
  return (
    <div
      className={`loonopzand-dashboard__likert-axis${
        compact ? " loonopzand-dashboard__likert-axis--compact" : ""
      }${periodOnly ? " loonopzand-dashboard__likert-axis--period-only" : ""}`}
      style={{ "--likert-question-count": groups.length }}
    >
      {groups.map((group) => {
        let previousYear = null;
        const groupIssues = group.issues || issues;
        return (
          <div
            key={group.key}
            className="loonopzand-dashboard__likert-axis-group"
          >
            {!periodOnly && (
              <div className="loonopzand-dashboard__likert-statement">
                {group.label}
              </div>
            )}
            <div className="loonopzand-dashboard__likert-periods">
              {groupIssues.map((issue) => {
                const match = /^(\d{4})-Q([1-4])$/.exec(issue);
                const year = match?.[1] || "";
                const quarter = match ? `Q${match[2]}` : issue;
                const showYear = year !== previousYear;
                previousYear = year;
                return (
                  <div key={issue} className="loonopzand-dashboard__likert-period">
                    <span>{showYear ? year : ""}</span>
                    <span>{quarter}</span>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
